import { render, staticRenderFns } from "./yinzhang_mng.vue?vue&type=template&id=abdb037a&scoped=true&"
import script from "./yinzhang_mng.vue?vue&type=script&lang=js&"
export * from "./yinzhang_mng.vue?vue&type=script&lang=js&"
import style0 from "./yinzhang_mng.vue?vue&type=style&index=0&id=abdb037a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abdb037a",
  null
  
)

export default component.exports